interface PlayButtonProps {
  sliderPlaying: boolean;
  handleTogglePlay: () => void;
}

const PlayButton: React.FC<PlayButtonProps> = ({ sliderPlaying, handleTogglePlay }) => {
  return (
    <button
      onClick={(e) => {
        e.stopPropagation();
        handleTogglePlay();
      }}
      style={{
        position: "absolute",
        top: "10px",
        left: "10px",
        zIndex: 10,
        backgroundColor: "darkred",
        color: "#fff",
        padding: "5px 10px",
        borderRadius: "5px",
        fontWeight: "bold",
      }}
    >
      {sliderPlaying ? "Pause" : "Play"}
    </button>
  );
};

export default PlayButton;
